import { render, staticRenderFns } from "./HrSalaryWealStd.vue?vue&type=template&id=cf3c40a2&scoped=true&"
import script from "./HrSalaryWealStd.vue?vue&type=script&lang=js&"
export * from "./HrSalaryWealStd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf3c40a2",
  null
  
)

export default component.exports